import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c7f1b33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-panel-content" }
const _hoisted_2 = {
  key: 0,
  class: "global-loading"
}
const _hoisted_3 = ["data-group"]
const _hoisted_4 = {
  key: 2,
  class: "canvas-wrapper"
}
const _hoisted_5 = {
  id: "js-canvas-container",
  class: "canvas-container"
}
const _hoisted_6 = ["width", "height"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add-icon" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 4,
  class: "season-game-panel-footer"
}
const _hoisted_11 = { class: "layout-inner -wide" }
const _hoisted_12 = { class: "footer-buttons" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-trash-alt icon" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "トーナメントを作り直す", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-history icon" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "最初からやり直す", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "トーナメントを保存", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestGrouping = _resolveComponent("RequestGrouping")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.tournament.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_ctx.existTournament)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "ssbeePgStyle ssbee-TN",
              id: "ssbee-TN",
              "data-group": _ctx.$route.query.group
            }, null, 8, _hoisted_3))
          : (_ctx.existEntryTeams)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("canvas", {
                    id: "js-canvas-display",
                    class: "canvas-display",
                    width: _ctx.canvas.width,
                    height: _ctx.canvas.height
                  }, null, 8, _hoisted_6),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineButtons.list, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.time
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.buttons, (button, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (button.isShow)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "button",
                                style: _normalizeStyle({
                  position: 'absolute', top: button.top + 'px', left: button.left + 'px',
                  width: _ctx.canvas.button.width + 'px', height: _ctx.canvas.button.height + 'px'}),
                                onClick: ($event: any) => (_ctx.addLine(button))
                              }, _hoisted_9, 12, _hoisted_7))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ], 64))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createBlock(_component_RequestGrouping, {
                key: 3,
                name: "トーナメント"
              })),
      (_ctx.existEntryTeams)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.existTournament)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "global-button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openTournamentDialogDelete && _ctx.openTournamentDialogDelete(...args)))
                    }, _hoisted_15))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "global-button",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setTournament && _ctx.setTournament(...args)))
                      }, _hoisted_18),
                      _createElementVNode("button", {
                        type: "button",
                        class: "global-button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickSave && _ctx.onClickSave(...args)))
                      }, _hoisted_21)
                    ], 64))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.tournamentDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.tournamentDialogDelete,
          onCloseDialog: _ctx.closeTournamentDialogDelete,
          onOnConfirm: _ctx.deleteGroupGames
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}